import { AppState } from "reducers";

export const getSeatBasedPricingEnvData = (state: AppState) =>
  state.environment.seatBased;
